import Vue from 'vue'
import Router from 'vue-router'
import Accueil from '@/view/Accueil'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:nom?',
      name: 'Accueil',
      component: Accueil
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js